module.exports = __webpack_public_path__ + "static/icon_max+-a0f962dfbda057ab2d14f666fd86475b.png";